import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormDataService } from '../data.service';

@Injectable()
export class UnlockFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private statusService: FormStatusService,
    private swal: SwalService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      this.swal
        .yesOrNo({
          title: 'Unlock this form for editing?',
          text:
            'If "Yes" the processing status of this form will be set back to "Pending."'
        })
        .then(() => {
          that.swal.load('Updating form to "Pending" status...');
          that.statusService.changeStatus('Pending');
          that.dataService.saveForm().subscribe(
            success => {
              that.swal
                .success({
                  title: 'Form unlocked for editing!',
                  text: "You may now make modifications to this form's details."
                })
                .then(resolve)
                .catch(resolve);
            },
            error => {
              if (error === 409) {
                reject(error);
              } else {
                reject(
                  'We are unable to update your form at this time. Please try again later.'
                );
              }
            }
          );
        })
        .catch(resolve);
    });
  }
}
